/* eslint-disable react/destructuring-assignment */
import { useTranslation } from 'react-i18next';
import { Link as OriginalLink, LinkProps } from 'react-router-dom';
import { useEditModeValue } from '../layouts/LoginedLayout';

/**
 * リンク遷移時にワーニングが表示される Link コンポーネント
 * @param props
 * @returns
 */
function Link(props: LinkProps & React.RefAttributes<HTMLAnchorElement>) {
  // 編集モードかどうか
  const editMode = useEditModeValue();

  // 言語情報
  const { t } = useTranslation();

  return (
    <OriginalLink
      {...props}
      onClick={(e) => {
        // eslint-disable-next-line no-alert
        if (editMode && !window.confirm(t('入力されたデータは保存されていませんが、よろしいですか？').toString())) {
          e.preventDefault();
        }
      }}
    >
      {props.children}
    </OriginalLink>
  );
}

export default Link;
